import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DataTableHead as RmwcDataTableHead} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

const StyledRmwcDataTableHead = styled(RmwcDataTableHead)``

const DataTableHead = ({children, ...otherProps}) => <StyledRmwcDataTableHead {...otherProps}>{children}</StyledRmwcDataTableHead>

DataTableHead.propTypes = {
  children: PropTypes.any
}

export {DataTableHead}
